<script setup lang="ts">
import { useWishlistLoadingState } from '~/composables/useWishlists/useWishlistLoadingState';

import { LoadingBadge } from '~/components/LoadingBadge';

// isWishlistLoading já é SSR-friendly (retorna true no servidor)
// Isso garante que SSR HTML === Client hydration HTML (sem mismatch)
const { isWishlistLoading, wishlistsState } = useWishlistLoadingState();
</script>

<template>
	<div
		class="flex w-full items-center justify-between text-sm font-normal leading-[21px] text-white"
	>
		<span>Minha coleção</span>

		<!-- Loading spinner (SSR e client enquanto busca dados) -->
		<LoadingBadge v-if="isWishlistLoading" />

		<!-- Contador de propriedades -->
		<span
			v-else-if="
				wishlistsState?.propertyCount && wishlistsState.propertyCount > 0
			"
			class="relative size-5 rounded-full bg-primary-light-3 text-xs"
		>
			<span class="absolute inset-0 flex items-center justify-center">
				{{ wishlistsState.propertyCount }}
			</span>
		</span>

		<!-- Estado vazio (sem favoritos) -->
		<span v-else class="relative size-5 rounded-full bg-transparent text-xs">
			<!-- Empty span to maintain consistent structure -->
		</span>
	</div>
</template>
